import { BufferGeometry, type Mesh } from "three"
import creaseMeshGeometryNormals from "../../../fn/creaseMeshGeometryNormals"
import loadSingleModelAndMerge from "../../../fn/loadSingleModelAndMerge"
import {
  Quaternius_UltimateNaturePack_CommonTree_CommonTree_Dead_1_GLTF_Model,
  Quaternius_UltimateNaturePack_CommonTree_CommonTree_Dead_2_GLTF_Model,
  Quaternius_UltimateNaturePack_CommonTree_CommonTree_Dead_3_GLTF_Model,
  Quaternius_UltimateNaturePack_CommonTree_CommonTree_Dead_4_GLTF_Model,
  Quaternius_UltimateNaturePack_CommonTree_CommonTree_Dead_5_GLTF_Model,
  Quaternius_UltimateNaturePack_Willow_Willow_Dead_1_GLTF_Model,
  Quaternius_UltimateNaturePack_Willow_Willow_Dead_2_GLTF_Model,
  Quaternius_UltimateNaturePack_Willow_Willow_Dead_4_GLTF_Model,
  Quaternius_UltimateNaturePack_Willow_Willow_Dead_5_GLTF_Model
} from "../../../gltf_models.generated"

// Cache for loaded geometries
let cachedPromise: Promise<BufferGeometry[]> | undefined

function meshTest (mesh: Mesh) {
  creaseMeshGeometryNormals(mesh)
  return true
}

export default function loadAndMergeDeadwoodTreeGeometry(): Promise<BufferGeometry[]> {
  if (!cachedPromise) {
    // console.log('Loading Deadwood tree models...')
    
    cachedPromise = Promise.all([
      loadSingleModelAndMerge(Quaternius_UltimateNaturePack_Willow_Willow_Dead_1_GLTF_Model, 2, meshTest),
      loadSingleModelAndMerge(Quaternius_UltimateNaturePack_Willow_Willow_Dead_2_GLTF_Model, 2, meshTest),
      loadSingleModelAndMerge(Quaternius_UltimateNaturePack_Willow_Willow_Dead_4_GLTF_Model, 2, meshTest),
      loadSingleModelAndMerge(Quaternius_UltimateNaturePack_Willow_Willow_Dead_5_GLTF_Model, 2, meshTest),
      loadSingleModelAndMerge(Quaternius_UltimateNaturePack_CommonTree_CommonTree_Dead_1_GLTF_Model, 2, meshTest),
      loadSingleModelAndMerge(Quaternius_UltimateNaturePack_CommonTree_CommonTree_Dead_2_GLTF_Model, 2, meshTest),
      loadSingleModelAndMerge(Quaternius_UltimateNaturePack_CommonTree_CommonTree_Dead_3_GLTF_Model, 2, meshTest),
      loadSingleModelAndMerge(Quaternius_UltimateNaturePack_CommonTree_CommonTree_Dead_4_GLTF_Model, 2, meshTest),
      loadSingleModelAndMerge(Quaternius_UltimateNaturePack_CommonTree_CommonTree_Dead_5_GLTF_Model, 2, meshTest),
    ])
  }

  return cachedPromise
}
